__turbopack_context__.v({
  "splide__arrow": "_24GNYG_splide__arrow",
  "splide__list": "_24GNYG_splide__list",
  "splide__slide": "_24GNYG_splide__slide",
});
